import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';

import formsActions from '../../redux/forms/actions';
import FormList from '../../components/FormList';
import SidebarContainer from '../SidebarContainer';
import DealerNav from '../../components/DealerNav';
import ContentPage from '../ContentPage';
import './Forms.scss';

class Forms extends Component {
  componentDidMount() {
    const { match } = this.props;
    const { dealerId } = match.params;
    this.props.actions.formsRequest(dealerId);
  }

  render() {
    const { forms, dealer, actions } = this.props;
    return (
      <SidebarContainer title={dealer.name} logo={dealer.logo}>
        <div className="forms-table">
          <DealerNav />
          <FormList
            dealer={dealer}
            list={forms.forms}
            error={forms.error}
            fetching={forms.fetching}
            onDelete={actions.deleteFormRequest}
            history={this.props.history}
          />
        </div>
      </SidebarContainer>
    );
  }
}

Forms.propTypes = {
  forms: PropTypes.object,
  dealer: PropTypes.object,
  history: PropTypes.object,
  actions: PropTypes.object,
  match: PropTypes.object,
};

const mapStateToProps = ({ forms }) => ({
  forms,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      ...formsActions,
    },
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContentPage(Forms));
